import React, { useEffect, useRef } from 'react'
import { Animated, StyleSheet, View, ViewStyle } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'

interface SkeletonProps {
  width?: number | string
  height?: number | string
  borderRadius?: number
  style?: ViewStyle
  animated?: boolean
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = 20,
  borderRadius = 4,
  style,
  animated = true,
}) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const shimmerAnim = useRef(new Animated.Value(0)).current

  useEffect(() => {
    if (animated) {
      const animation = Animated.loop(
        Animated.sequence([
          Animated.timing(shimmerAnim, {
            toValue: 1,
            duration: 1000,
            useNativeDriver: true,
          }),
          Animated.timing(shimmerAnim, {
            toValue: 0,
            duration: 1000,
            useNativeDriver: true,
          }),
        ])
      )
      animation.start()
      return () => animation.stop()
    }
  }, [animated, shimmerAnim])

  const opacity = animated
    ? shimmerAnim.interpolate({
        inputRange: [0, 1],
        outputRange: [0.3, 0.7],
      })
    : 0.3

  // Separate static styles from animated styles to avoid type conflicts
  const staticStyle: ViewStyle = {
    width: width as number | `${number}%`,
    height: height as number | `${number}%`,
    borderRadius,
  }

  return (
    <Animated.View
      style={[
        styles.skeleton,
        staticStyle,
        {
          opacity,
        } as any,
        style,
      ]}
    />
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    skeleton: {
      backgroundColor: theme.colors.grey,
    },
  })

